import { useTranslation } from 'react-i18next';

import keys from './option-keys.json';

const getTranslatedDict = (keys, t) => {
  return keys.reduce((result, current) => {
    result[current] = t(current, { ns: ['countries', 'translation'] });
    return result;
  }, {});
};

const useTranslatedOptions = () => {
  const { t } = useTranslation(['countries', 'translation']);

  const getCountries = () => {
    return getTranslatedDict(keys.countries, t);
  };
  getCountries.keys = Object.keys(keys.countries);
  getCountries.values = Object.values(keys.countries);

  const getMainGenre = () => {
    return getTranslatedDict(keys.mainGenre, t);
  };
  getMainGenre.keys = keys.mainGenre;

  const getProfileStatement = () => {
    return getTranslatedDict(keys.profileStatement, t);
  };
  getProfileStatement.keys = keys.profileStatement;

  const getPhotoSkills = () => {
    return getTranslatedDict(keys.photoSkills, t);
  };
  getPhotoSkills.keys = keys.photoSkills;

  const getVideoSkills = () => {
    return getTranslatedDict(keys.videoSkills, t);
  };
  getVideoSkills.keys = keys.videoSkills;

  const getPrintStatement = () => {
    return getTranslatedDict(keys.printStatement, t);
  };
  getPrintStatement.keys = keys.printStatement;

  const getAgeStatement = () => {
    return getTranslatedDict(keys.ageStatement, t);
  };
  getAgeStatement.keys = keys.ageStatement;

  const getProfessionStatement = () => {
    return getTranslatedDict(keys.professionStatement, t);
  };
  getProfessionStatement.keys = keys.professionStatement;

  const getProductStatement = () => {
    return getTranslatedDict(keys.productStatement, t);
  };
  getProductStatement.keys = keys.productStatement;

  return {
    getCountries,
    getMainGenre,
    getPhotoSkills,
    getVideoSkills,
    getAgeStatement,
    getPrintStatement,
    getProfileStatement,
    getProductStatement,
    getProfessionStatement,
  };
};

export default useTranslatedOptions;
